<template>
  <el-card>
    <el-alert
      type="warning"
      :closable="false"
      class="text-left"
    >
      When you reset your OpenFreight password, all other active sessions will be signed out.
    </el-alert>

    <ResetPasswordForm
      :code.sync="code"
      :email.sync="email"
      :password.sync="password"
      class="pt-3 pb-4"
    />

    <el-button
      type="primary"
      class="w-100"
      :loading="isResettingPassword"
      @click.native="resetPassword"
    >
      Reset password
    </el-button>

    <el-divider />

    <el-link
      type="primary"
      @click.native="$router.push({ name: 'authentication-signin' })"
    >
      Return to sign in
    </el-link>
  </el-card>
</template>

<script>
import ResetPasswordForm from '@/components/Authentication/ResetPasswordForm'
import Request, { PUT } from '@/plugins/sdk/Request'

export default {
  components: {
    ResetPasswordForm
  },
  data () {
    return {
      isResettingPassword: false,
      code: '',
      email: '',
      password: ''
    }
  },
  created () {
    if (this.$route.query.code) {
      this.code = this.$route.query.code
    }

    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  },
  methods: {
    async resetPassword () {
      this.isResettingPassword = true

      const request = await (Object.assign(new Request(), {
        method: PUT,
        _pathname: 'authenticate/reset',
        body: {
          email: this.email,
          pin: this.code,
          password: this.password
        }
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message.success('Your password has been reset')
        this.$router.push({ name: 'authentication-signin', query: { email: this.email } })
      }

      this.isResettingPassword = false
    }
  }
}
</script>
